<div class="charts-container">
  <div class="chart-wrapper">
    <mat-card-subtitle>Monthly traffic data chart showing number of results</mat-card-subtitle>
    <div style="display: block; height: 15vh; min-height: 150px; max-height: 300px">
      <canvas baseChart [datasets]="resultsDataset$ | async" [labels]="ts.trafficLabels | async" [options]="resultsChartOptions" [legend]="false" chartType="bar" [attr.aria-label]="'Monthly traffic data chart showing number of results'" role="img"> </canvas>
    </div>
  </div>

  <div class="chart-wrapper">
    <mat-card-subtitle>Monthly traffic data chart showing completion percentage</mat-card-subtitle>
    <div style="display: block; height: 15vh; min-height: 150px; max-height: 300px">
      <canvas baseChart [datasets]="completionDataset$ | async" [labels]="ts.trafficLabels | async" [options]="completionChartOptions" [legend]="false" chartType="bar" [attr.aria-label]="'Monthly traffic data chart showing completion percentage'" role="img"> </canvas>
    </div>
  </div>

  <!-- Screen reader accessible table -->
  <div class="sr-only">
    <table>
      <caption>
        Monthly Traffic Data Table
      </caption>
      <thead>
        <tr>
          <th scope="col">Period</th>
          <th scope="col">Results</th>
          <th scope="col">Completion %</th>
        </tr>
      </thead>
      <tbody>
        @for (label of ts.trafficLabels | async; track label; let i = $index) {
          <tr>
            <td>{{ label }}</td>
            <td>{{ (resultsDataset$ | async)?.[0]?.data?.[i] }}</td>
            <td>{{ (completionDataset$ | async)?.[0]?.data?.[i] }}%</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
